import { useNavigate } from "react-router-dom";
import React, { useState, useEffect, useRef } from "react";
import {
    collection,
    query,
    where,
    getDocs,
    setDoc,
    doc,
    onSnapshot,
    deleteDoc
} from "firebase/firestore";
import { db } from "../../firebase";
import Cookies from "js-cookie";
import { Toast } from '../../components_root/ToastContext';
import { MdOutlineVerifiedUser, MdClose } from "react-icons/md";
import "../../body_root/popup.css";

export default function Settingprint_popup({ data, isOpen, onClose }) {

    const panelRef = useRef(null);
    const { Toastshow } = Toast();
    const navigate = useNavigate();

    const servicetablename = "accountingfinancedb";

    const [IsLoading2, setIsLoading2] = useState(true);
    const [printdata, setPrintdata] = useState([]);
    const [printpage, setPrintpage] = useState("");
   useEffect(() => {
        if (!isOpen) return;

        const handleEsc = (e) => {
            if (e.key === "Escape") {
                onClose();
            }
        };

        document.addEventListener("keydown", handleEsc);
        return () => document.removeEventListener("keydown", handleEsc);
    }, [isOpen, onClose]);
    /* ------------------------------------
       SET PRINT PAGE SAFELY
    ------------------------------------ */
    useEffect(() => {
        if (typeof data === "string" && data.trim()) {
            setPrintpage(data.toLowerCase());
        }
    }, [data]);

    /* ------------------------------------
       CLOSE ON OUTSIDE CLICK
    ------------------------------------ */
    useEffect(() => {
        const onDocClick = (e) => {
            if (isOpen && panelRef.current && !panelRef.current.contains(e.target)) {
                onClose?.();
            }
        };
        document.addEventListener("mousedown", onDocClick);
        return () => document.removeEventListener("mousedown", onDocClick);
    }, [isOpen, onClose]);

    /* ------------------------------------
       FETCH PRINT SETTINGS
    ------------------------------------ */
useEffect(() => {
    if (!printpage) return;

    const guid = Cookies.get("guid");
    const companyUid = Cookies.get("select_company_uid");

    if (!guid || !companyUid) return;

    setIsLoading2(true);

    const printSettingRef = collection(
        db,
        servicetablename,
        companyUid,
        "print_setting"
    );

    const applyRef = collection(
        db,
        servicetablename,
        companyUid,
        "print_settings_account_apply"
    );

    // 🔴 Listen to APPLY DATA (LIVE)
    const unsubscribeApply = onSnapshot(
        query(
            applyRef,
            where("guid", "==", guid),
            where("printpage", "==", printpage)
        ),
        (applySnap) => {

            const applyMap = {};
            applySnap.docs.forEach(doc => {
                const d = doc.data();
                applyMap[d.printid] = { id: doc.id, ...d };
            });

            // 🔴 Listen to PRINT SETTINGS (LIVE)
            const unsubscribePrint = onSnapshot(printSettingRef, (printSnap) => {

                const list = printSnap.docs.map(docSnap => {
                    const d = docSnap.data();
                    const printId = docSnap.id;

                    const settingObj = {};
                    (d.settingdata || [])
                        .sort((a, b) => a.index - b.index)
                        .forEach(item => {
                            settingObj[item.key] = item.value;
                        });

                    return {
                        id: printId,
                        ...d,
                        applydata: applyMap[printId] ? [applyMap[printId]] : [],
                        settingdata: settingObj
                    };
                });

                setPrintdata(list);
                setIsLoading2(false);
            });

            // cleanup inner listener
            return () => unsubscribePrint();
        }
    );

    // cleanup outer listener
    return () => unsubscribeApply();

}, [printpage]); 
    /* ------------------------------------
       APPLY PRINT SETTING
    ------------------------------------ */
    const set_print_setting_apply = async (printid, data) => {

        const guid = Cookies.get("guid");
        const companyUid = Cookies.get("select_company_uid");

        if (!guid || !companyUid || !printpage || !printid) return;

        const collectionRef = collection(
            db,
            servicetablename,
            companyUid,
            "print_settings_account_apply"
        );

        const duplicateQuery = query(
            collectionRef,
            where("guid", "==", guid),
            where("printpage", "==", printpage)
        );

        const snapshot = await getDocs(duplicateQuery);

        for (const docSnap of snapshot.docs) {
            await deleteDoc(docSnap.ref);
        }

        const newRef = doc(collectionRef);

        await setDoc(newRef, {
            ...data,
            uid: newRef.id,
            printid,
            printpage,
            guid,
            companyuid: companyUid,
            status: true,
            date_time: new Date(),
            date_time_update: new Date()
        });

        Toastshow("Change Successfully");
        onClose?.();
    };

    /* ------------------------------------
       UI
    ------------------------------------ */
    return (
        <div className={`div-popup-body ${isOpen ? "show" : ""}`}>
            <div ref={panelRef} className={`overflow-auto div-panel-right ${isOpen ? "slide-in" : "slide-out"}`}>

                <div className="b-bottom items-back">
                    <table>
                        <tbody>
                            <tr>
                                <td>
                                    <div className="button-ui0 text-h2 bold p-2 fcap">
                                        <MdOutlineVerifiedUser className="icon" />
                                        Setting print on {printpage}
                                    </div>
                                </td>
                                <td width={30}>
                                    <div onClick={onClose} className="button-ui0 p-2 cursor">
                                        <MdClose className="icon" />
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className="p-2">
                    {IsLoading2 ? null : printdata.length === 0 ? (
                        <div className="text-h2 bold p-5">No Print Found</div>
                    ) : (
                        printdata.map((row) => {

                            const applied =
                                row.applydata?.length > 0 &&
                                row.applydata[0].printpage === printpage;

                            return (
                                <div className="m-1" key={row.id}>
                                    <div
                                        className={`ui-items p-11 cursor shadow rounded ${
                                            applied ? "b-1-green" : ""
                                        }`}
                                        onClick={() => !applied && set_print_setting_apply(row.id, row)}
                                    >
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td className="text-h3 text-off">Print Name</td>
                                                    <td>
                                                        <div className="text-h2   fcap">{row.print_name}</div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="text-h3 text-off">Print Size</td>
                                                    <td>
                                                        <div className="text-h2">
                                                            {row.printsize} 
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            );
                        })
                    )}
                </div>

            </div>
        </div>
    );
}
